<div class="voice-call">
  <ng-container
    *ngIf="
      voiceCallView === EMicStatus.DENIED ||
      voiceCallView === EMicStatus.NO_DEVICE ||
      voiceCallView === EMicStatus.ERROR
    "
  >
    <div class="voice-call_toast">
      <stxt-toast
        [toast]="toastConfig"
        (closeToast)="closeVoiceCall.emit()"
        (buttonEvent)="buttonClicked($event)"
      ></stxt-toast>
    </div>
  </ng-container>

  <ng-container *ngIf="voiceCallView === EMicStatus.GRANTED">
    <div class="voice-call_main">
      <div class="voice-call_content">
        <h2 class="voice-call_name">{{ creatorData.name }}</h2>
        <div
          [ngStyle]="{ 'margin-bottom': lowTokensBalance ? '44px' : '80px' }"
          class="voice-call_info"
        >
          <time
            [ngStyle]="{ color: lowTokensBalance ? '#F8D09A' : '#6f5c6e' }"
            class="voice-call_info__duration"
          >
            {{ callDuration | timeFormat }}
          </time>
          <p *ngIf="lowTokensBalance" class="voice-call_info__warning">
            <stxt-svg-icon [iconConfig]="warningSvg" class="voice-call_warning-svg"></stxt-svg-icon>
            No more tokens • 1 minute left
          </p>
        </div>
        <div
          [ngClass]="{ 'voice-call_image--creator-speaking': isCreatorSpeaking }"
          [ngStyle]="{ '--creator-volume-level': creatorResponseVolume }"
          class="voice-call_image"
        >
          <img [src]="creatorData.image" [alt]="creatorData.name" />
        </div>
        <span
          [ngStyle]="{ opacity: voiceCallState !== 'AI ready' ? '1' : '0' }"
          class="voice-call_listening"
        >
          {{ voiceCallState }}...
        </span>
        <div class="voice-call_dot-container">
          <div
            [ngClass]="{ 'voice-call_dot--speaking': isSpeaking }"
            [ngStyle]="{ '--volume-level': currentVolume }"
            class="voice-call_dot"
          ></div>
        </div>
        <div class="voice-call_controls">
          <div class="voice-call_controls__button">
            <stxt-svg-icon
              [iconConfig]="isMuted ? unmuteSvg : microphoneSvg"
              (click)="toggleMute()"
              (keydown.enter)="toggleMute()"
              tabindex="-1"
              class="mute-icon"
            ></stxt-svg-icon>
            <p>{{ isMuted ? 'Unmute' : 'Mute' }}</p>
          </div>
          <div class="voice-call_controls__button">
            <stxt-svg-icon
              [iconConfig]="endCallSvg"
              (click)="endCall()"
              (keydown.enter)="endCall()"
              class="end-call-icon"
              tabindex="-1"
            ></stxt-svg-icon>
            <p>End call</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
